export default {
    data() {
        return {
            url_img: '',
            vip_icon: sessionStorage.getItem('vip_icon') || '',
        }
    },
    beforeMount() {
        this.url_img = this.$url_img
    },
    methods: {

    }
}